import { Component, Fragment } from 'react';
import { Route } from 'react-router';
import { ApplicationPaths } from '../Services/Auth/AuthConstants';
import { Callback } from './Auth/Callback';
import { LogoutCallback } from './Auth/LogoutCallback';
import { Logout } from './Auth/Logout';
import { Login } from './Auth/Login';

interface IProps{
}

export default class ApiAuthorizationRoutes extends Component<IProps,any> {

  render () {
    return(
      <Fragment>
        <Route exact={true} path={ApplicationPaths.LoginCallback} component={Callback} />
        <Route path={`${ApplicationPaths.Login}/:emailAddress?/:redirectUrl?`} component={Login} />
        <Route exact={true} path={ApplicationPaths.LogOut} component={Logout} />
        <Route exact={true} path={ApplicationPaths.LogOutCallback} component={LogoutCallback} />
      </Fragment>);
  }
}
